export default function () {
  const tableRows = document.getElementsByClassName('clickable-row');

  if (tableRows.length) {
    for (let tableRow of tableRows) {
      tableRow.addEventListener('click', function () {
        window.location = tableRow.dataset.href;
      });
    }
  }
};